/**
 * Roles del waitlist orientados a CROs y centros de investigación.
 * Las etiquetas (`label`) son las que se envían a Airtable en selección única:
 * deben existir como opciones exactas en la columna Role de la base.
 */
export const WAITLIST_ROLE_OPTIONS = [
  { value: 'ceo-founder', label: 'CEO / Founder' },
  {
    value: 'medical-director-pi',
    label: 'Medical Director / Principal Investigator',
  },
  { value: 'clinical-operations', label: 'Clinical Operations Lead' },
  {
    value: 'crc',
    label: 'Clinical Research Coordinator (CRC)',
  },
  { value: 'regulatory', label: 'Regulatory Affairs' },
  { value: 'business-development', label: 'Business Development' },
  { value: 'clinical-pm', label: 'Clinical Project Manager' },
  {
    value: 'site-management',
    label: 'Site Management / Feasibility',
  },
  {
    value: 'data-biometrics',
    label: 'Data Management / Biometrics',
  },
  { value: 'other', label: 'Other' },
] as const;

/** Mapa value interno → texto para Airtable (mismo que `label` en el formulario). */
export const ROLE_LABEL_BY_VALUE: Record<string, string> =
  Object.fromEntries(WAITLIST_ROLE_OPTIONS.map((o) => [o.value, o.label])) as Record<
    string,
    string
  >;
